module.exports = __webpack_public_path__ + "img/Hoffman.eaeabdd7.jpg";